/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import HeaderTable from '../BaseComponent/HeaderTable'
import Page from '../Pagination/Pagination'
import $ from 'jquery'
import {message} from 'antd'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import A4Style from '../BaseComponent/printA4Style'
import cookie from 'react-cookies'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import SearchableCombo from '../BaseComponent/searchableCombo'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import Loader from '../loaders/loader'
import AutoComplete from '../BaseComponent/autocomplete'
class Providers extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      Providers: [],
      comboProvides: [],
      printInfo: [],
      lengthProviders: 0,
      pageNumber: 1
    }
  }

  componentDidMount() {
    sessionStorage.removeItem('params')

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')

    // http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {}).then((response) => {

    //     if (response.data.error == null) {

    //         var result = response.data.object;
    //         for (let i = 0; i < result.length; i++) {
    //             result[i]['value'] = result[i].providerId;
    //             result[i]['label'] =result[i].providerId +' - '+ result[i].title;
    //         }

    //         this.setState({
    //             providers: response.data.object
    //         })
    //     }
    //     // alert(JSON.stringify(response.data))
    // }).catch((error) => {
    //     alert(JSON.stringify(error))
    // });

    this.setState({
      loading: true
    })

    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_PROVIDER}?export=false&pageSize=10&pageNumber=1`, {})
      .then((response) => {
        this.setState({
          loading: false
        })
        let Products = response.data.object.result

        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)

          this.setState({
            Providers: response.data.object.result,
            lengthProviders: response.data.object.countAll
          })
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
        alert(JSON.stringify(error))
      })
  }

  onResultFetched(data) {
    this.setState({
      Providers: data
    })
  }

  changeDropDown(data) {
    this.setState({
      Providers: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  getValueProvider = (providerId) => {
    this.setState({
      providerId
    })
  }

  filter() {
    var providerId = this.state.providerId
    let active = document.getElementById('active').value
    sessionStorage.setItem('params', `&providerId=${providerId}&active=${active}`)
    this.setState({
      loading: true
    })
    http
      .get(
        `${
          REPORT_RETAIL.REPORT_RETAIL_PROVIDER
        }?export=false&pageSize=10&pageNumber=1&providerId=${providerId}&active=${active}`,
        {}
      )
      .then((response) => {
        console.log(response)
        this.setState({
          loading: false
        })
        if (response.data.error == null) {
          $('.showBaseTable').fadeIn()

          this.setState({
            Providers: response.data.object.result,
            lengthProviders: response.data.object.countAll
          })
        } else {
          this.setState({
            loading: false
          })
          $('.showBaseTable').fadeOut()
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
  }

  exportExcel = () => {
    http
      .get(
        `${REPORT_RETAIL.REPORT_RETAIL_PROVIDER}?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem(
          'params'
        )}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_PROVIDER}?export=true&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        console.log(response)

        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)

          this.setState({
            printInfo: response.data.object.result
          })
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  render() {
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let excelColumns = [
      {title: 'نام تامین کننده', value: 'title'},
      {title: 'شناسه تامین کننده', value: 'providerId'},
      {title: 'کد ملی', value: 'nationalId'},
      {title: 'کد اقتصادی', value: 'economicCode'}
    ]
    let name = cookie.load('name')
    let columns = ['ردیف', 'نام تامین کننده', 'شناسه تامین کننده ', 'کد ملی', 'کد اقتصادی']
    let urlParams = sessionStorage.getItem('params')

    return (
      <div className="rtl printA4Page">
        <Loader show={this.state.loading} />

        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="لیست تامین کنندگان"
              headerColSpan={5}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={3}
              rightColSpan={1}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((providers, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{providers.title}</td>
                  <td>{providers.providerId}</td>
                  <td>{providers.nationalId}</td>
                  <td>{providers.economicCode}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش تامین کنندگان.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'title'}
                field={'title'}
                title={'نام'}
                width="250px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'providerId'}
                field={'providerId'}
                title={'شناسه'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'nationalId'}
                field={'nationalId'}
                title={'کد ملی'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'economicCode'}
                field={'economicCode'}
                title={'کد اقتصادی'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>لیست تامین کنندگان</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl=""
                  printUrl="print"
                  url={REPORT_RETAIL.REPORT_RETAIL_PROVIDER}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printComponent={this.printTable}
                  execelUrl={REPORT_RETAIL.REPORT_RETAIL_PROVIDER + '?export=true'}
                  excelColumns={excelColumns}
                  titleAdd=""
                  printLink=""
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <div className="formComponent selectComponent">
                  <AutoComplete
                    label="تامین کننده"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.providerId}
                    setValue={(providerId) => this.setState({providerId})}
                  />
                  {/* <SearchableCombo
                                        options={this.state.providers}
                                        getValueCombo={this.getValueProvider}
                                        lableText='تامین کنندگان'
                                        placeholder='------'
                                        isClearable={true}
                                        isMulti={false}
                                        isDisabled={false}
                                    /> */}
                </div>
                <div className="formComponent">
                  <label>فعال</label>
                  <select id="active" className="form-control">
                    <option value={''}>------</option>
                    <option value={true}>بله</option>
                    <option value={false}>خیر</option>
                  </select>
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>نام تامین کننده</td>
                    <td>شناسه تامین کننده</td>
                    <td>کدملی</td>
                    <td>کد اقتصادی</td>
                  </tr>
                  {this.state.Providers.map((providers, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{providers.title}</td>
                      <td>{providers.providerId}</td>
                      <td>{providers.nationalId}</td>
                      <td>{providers.economicCode}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.lengthProviders}
                  onResultFetched={this.onResultFetched.bind(this)}
                  url={REPORT_RETAIL.REPORT_RETAIL_PROVIDER}
                  urlParams={urlParams}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Providers
